import { HeadContent, Outlet, createRootRoute } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import { TanStackDevtools } from '@tanstack/react-devtools'
import { useEnableDevtools } from '@/app/state/preferences'

import '../styles.css'
import Theme from '@/app/theme'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  const enableDevtools = useEnableDevtools()

  return (
    <>
      <HeadContent />
      <Theme>
        <Outlet />
      </Theme>
      {enableDevtools ? (
        <TanStackDevtools
          config={{
            position: 'bottom-right',
          }}
          plugins={[
            {
              name: 'TanStack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
          ]}
        />
      ) : null}
    </>
  )
}
